module.exports = __webpack_public_path__ + "static/media/icon_faq_search.3a8007b6.svg";